import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'info' | 'warning' | 'loading';

export interface Toast {
  id: string;
  type: ToastType;
  title: string;
  message: string;
  duration?: number;
  metadata?: {
    ref?: string;
    timestamp?: string;
  };
}

interface ToastState {
  toasts: Toast[];
  addToast: (toast: Omit<Toast, 'id'>) => string;
  updateToast: (id: string, toast: Partial<Omit<Toast, 'id'>>) => void;
  removeToast: (id: string) => void;
}

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],
  addToast: (toast) => {
    const id = Math.random().toString(36).substring(2, 9);
    set((state) => ({
      toasts: [...state.toasts, { ...toast, id }],
    }));

    if (toast.duration !== 0 && toast.type !== 'loading') {
      setTimeout(() => {
        get().removeToast(id);
      }, toast.duration || 5000);
    }
    return id;
  },
  updateToast: (id, updatedToast) => {
    set((state) => ({
      toasts: state.toasts.map((t) => 
        t.id === id ? { ...t, ...updatedToast } : t
      ),
    }));

    // If it's no longer loading and has a duration, start timer
    if (updatedToast.type && updatedToast.type !== 'loading' && updatedToast.duration !== 0) {
      setTimeout(() => {
        get().removeToast(id);
      }, updatedToast.duration || 5000);
    }
  },
  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}));

